<template>
  <div>
    <h2>Subscription Revenue by Year</h2>
    <LineChart :chart-options="chartOptions" :chart-data="chartData" style="max-width: 700px; height: 400px;" />
  </div>
</template>

<script>
import { LineChart } from "vue-chart-3";
import { Chart, registerables } from "chart.js";

Chart.register(...registerables);

export default {
  components: {
    LineChart,
  },
  data() {
    // Your JSON data
    const subscriptionsData = {
      subscriptions: [
        { year: "2024", month_key: "04", month: "April", total_amount: 1250, status: { isActive: false, remaining_days: 0 } },
        { year: "2022", month_key: "08", month: "August", total_amount: 1250, status: { isActive: false, remaining_days: 0 } },
        { year: "2023", month_key: "06", month: "June", total_amount: 650, status: { isActive: false, remaining_days: 0 } },
        { year: "2024", month_key: "11", month: "November", total_amount: 1250, status: { isActive: false, remaining_days: 0 } },
        { year: "2024", month_key: "10", month: "October", total_amount: 1500, status: { isActive: false, remaining_days: 0 } },
        { year: "2024", month_key: "09", month: "September", total_amount: 650, status: { isActive: false, remaining_days: 0 } },
      ],
      total: "6,550.00",
    };

    // Extract unique months and sort them by month_key
    const months = [...new Set(subscriptionsData.subscriptions.map((sub) => sub.month_key))]
      .sort((a, b) => a - b)
      .map((monthKey) =>
        subscriptionsData.subscriptions.find((sub) => sub.month_key === monthKey).month
      );

    // Group data by year
    const groupedByYear = subscriptionsData.subscriptions.reduce((acc, sub) => {
      if (!acc[sub.year]) acc[sub.year] = {};
      acc[sub.year][sub.month_key] = sub.total_amount;
      return acc;
    }, {});

    // Create datasets for each year
    const datasets = Object.entries(groupedByYear).map(([year, data]) => ({
      label: `Year ${year}`,
      data: months.map((month) => {
        // Find the corresponding total_amount or use 0 if not present
        const monthKey = subscriptionsData.subscriptions.find((sub) => sub.month === month)?.month_key;
        return data[monthKey] || 0;
      }),
      borderColor: this.getRandomColor(),
      backgroundColor: "rgba(0, 0, 0, 0.1)",
      borderWidth: 2,
      tension: 0.4,
    }));

    return {
      chartData: {
        labels: months, // Only months as labels
        datasets, // Separate lines for each year
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: "top",
          },
          title: {
            display: true,
            text: "Subscription Revenue Comparison",
          },
        },
        scales: {
          x: {
            title: {
              display: true,
              text: "Months",
            },
          },
          y: {
            title: {
              display: true,
              text: "Revenue ($)",
            },
            beginAtZero: true,
          },
        },
      },
    };
  },
  methods: {
    // Helper function to generate random colors for datasets
    getRandomColor() {
      const letters = "0123456789ABCDEF";
      let color = "#";
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
  },
};
</script>

<style scoped>
h2 {
  text-align: center;
  margin-bottom: 20px;
}
</style>
